import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ChangeStatusToCompleteComponent} from './change-status-to-complete.component';
import {ReservationService} from '../reservations.service';
import {TripEditDriverVehicleModule} from '../trip-edit-driver-vehicle/trip-edit-driver-vehicle.module';
import {TextMaskModule} from 'angular2-text-mask';
import {Trip2ThemeModule} from '../../../trip2-theme/trip2-theme.module';
import {ManifestModule} from '../../A2-utils/manifest/manifest.module';
import {CropperModule} from '../../A2-utils/cropper/cropper.module';
import {TripManifestModule} from '../../A2-utils/trip-manifest/trip-manifest.module';
import {ReasonsDelayModule} from '../reasons-delay/reasons-delay.module';
import { InputTimeModule } from '../../../utils/input-time/input-time.module';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TripEditDriverVehicleModule,
    TextMaskModule,
    Trip2ThemeModule,
    ManifestModule,
    CropperModule,
    TripManifestModule,
    ReasonsDelayModule,
    InputTimeModule,
  ],
  declarations: [
    ChangeStatusToCompleteComponent
  ],
  exports: [
    ChangeStatusToCompleteComponent
  ],
  providers: [
    ReservationService,

  ]
})
export class ChangeStatusToCompleteModule { }



// WEBPACK FOOTER //
// ./src/app/pages/trip-reservations/change-status-to-complete/change-status-to-complete.module.ts